import api from './api';
import { Customer, CustomerLocation, CustomerStatusHistoryEntry } from '../types';

export interface CreateCustomerData {
  customer_code?: string;
  party_name: string;
  contact_person?: string;
  contact_no?: string;
  secondary_contact_person?: string;
  secondary_contact_no?: string;
  email?: string;
  office_address?: string;
  status?: 'active' | 'inactive' | 'dormant' | 'lost';
  doj?: string;
  last_bill_date?: string;
  sales_officer_id?: number;
  brand_id?: number;
  supplier_id?: number;
  work_order_value?: number;
  wo_allotment_date?: string;
  tenure_months?: number;
  product_req?: string;
  qty_req?: string;
  brand_in_use?: string;
  converted_from_lead_id?: number;
  locations?: CustomerLocation[];
}

export interface UpdateCustomerData extends Partial<CreateCustomerData> {}

export interface CustomerFilters {
  status?: string;
  sales_officer_id?: number;
  brand_id?: number;
  company_sales_person?: number;
  has_target_current_month?: boolean;
  search?: string;
  call_date_from?: string;
  call_date_to?: string;
  limit?: number;
  offset?: number;
}

export const customerService = {
  getAll: async (filters?: CustomerFilters): Promise<{ data: Customer[]; count: number; total: number }> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
    }
    const response = await api.get(`/api/customers?${params.toString()}`);
    return response.data;
  },

  getById: async (id: number): Promise<Customer> => {
    const response = await api.get(`/api/customers/${id}`);
    return response.data.data;
  },

  create: async (customerData: CreateCustomerData): Promise<Customer> => {
    const response = await api.post('/api/customers', customerData);
    return response.data.data;
  },

  update: async (id: number, customerData: UpdateCustomerData): Promise<Customer> => {
    const response = await api.put(`/api/customers/${id}`, customerData);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/customers/${id}`);
  },

  getTargets: async (customerId: number, year: number, month: number): Promise<{ year: number; month: number; locations: { customer_location_id: number; project_state?: string; project_district?: string; project_location?: string; target_tons: number }[] }> => {
    const response = await api.get(`/api/customers/${customerId}/targets?year=${year}&month=${month}`);
    return response.data;
  },

  setTargets: async (customerId: number, data: { year: number; month: number; targets: { customer_location_id: number; target_tons: number }[] }): Promise<void> => {
    await api.put(`/api/customers/${customerId}/targets`, data);
  },

  getStatusHistory: async (customerId: number): Promise<CustomerStatusHistoryEntry[]> => {
    const response = await api.get(`/api/customers/${customerId}/status-history`);
    return response.data.data ?? [];
  },
};




